<template>
    <section class="dashboard-invitation">
        <div class="dashboard-invitation__left">
            <div class="h3 dashboard-invitation__title">
                {{ title }}
            </div>
            <div class="text">
                {{ descr }}
            </div>
        </div>
        <div class="dashboard-invitation__right">
            <button
                type="button"
                class="cabinet-btn cabinet-btn--big dashboard-invitation__btn"
                @click="openModal"
            >
                Пригласить партнера
            </button>
        </div>

        <invite-modal
            :is-open="isModalOpen"
            @closeModal="closeModal"
            @onSend="saveModal"
        >
        </invite-modal>
    </section>
</template>

<script>
import InviteModal from '@/components/Elements/InviteModal'
import checkDemoUser from '@/mixins/checkDemoUser.js'

export default {
    name: 'Invitation',
    components: { InviteModal },
    mixins: [checkDemoUser],
    props: {
        title: {
            type: String,
            required: true
        },
        descr: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isModalOpen: false
        }
    },
    methods: {
        openModal() {
            if (this.isDemoUserMode()) return
            this.isModalOpen = true
        },
        closeModal() {
            this.isModalOpen = false
        },
        saveModal() {
            console.log('onMessageSend')
        }
    }
}
</script>
